import { ChartSetup } from "./enrollment.chart-controller";

var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/lollipop')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/dumbbell')(Highcharts);


export class ChartLine {

    constructor() { }

    UpdateChart(chartSetup: ChartSetup, chartTitle: string = null, chartId: string = 'enrollment-chart'): void {
        Highcharts.chart(chartId, {
            chart: {
                backgroundColor: 'white',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'top',
                        x: -10,
                        y: 0
                    },
                    relativeTo: 'chart'
                }
            },
            credits: { enabled: false },
            title: { text: chartTitle },
            xAxis: {
                type: 'datetime',
                //max: maxDate,
                showLastLabel: true,
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%b \'%y', this.value);
                    }
                }
            },
            yAxis: {
                //max: maxEnrollment,
                title: {
                    text: 'Number of Participants'
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',');
                    }
                }
            },
            plotOptions: {
                line: {
                    stickyTracking: false,
                    findNearestPointBy: 'xy',
                    marker: {
                        enabled: !chartSetup.moreThan15Points
                    }
                },
                lollipop: {
                    marker: {
                        enabled: true
                    }
                }
            },
            tooltip: {
                xDateFormat: '%e %b %Y',
                shared: chartSetup.sharedTooltip
            },
            legend: {
                enabled: chartSetup.showLegend,
                //symbolWidth: 0
            },
            series: chartSetup.series
        });
    }
}